'use client';

import { Paragraph } from '@koda/koda-components/atoms/Paragraph';
import { ReactNode } from 'react';

const FormHeadline = ({ title, description }: { title: string; description?: string | ReactNode }) => {
  return (
    <div className="space-y-2">
      <h2 className="font-graphik text-xl font-medium">{title}</h2>
      {description && typeof description === 'string' ? (
        <Paragraph text={description} />
      ) : (
        <div className="text-ellipsis break-normal text-black-900">{description}</div>
      )}
    </div>
  );
};

export default FormHeadline;
